import type { ReactElement } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useTranslation } from "next-i18next";

import { Layout } from "@/components/ui/Layout";
import { ForgotPasswordForm } from "@/components/elements/ForgotPasswordForm";

export default function ForgotPasswordPage() {
  const { t } = useTranslation("auth");

  return (
    <>
      <Head>
        <title>{`${t("forgot.forgotPassword")} | OwnSpace`}</title>
      </Head>
      <ForgotPasswordForm />
    </>
  )
}

ForgotPasswordPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

export const getStaticProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ["auth", "validation"]),
    }
  }
}
